<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item prop="name">
        <el-input v-model="queryParams.name" clearable placeholder="资费组名"></el-input>
      </el-form-item>
      <el-form-item prop="productName">
        <el-input v-model="queryParams.productName" clearable placeholder="套餐名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addItem">添加</el-button>
      </el-form-item>
    </el-form>

    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border :cell-style="cellStyle">
        <el-table-column prop="id" label="ID" align="center" width="60"></el-table-column>
        <el-table-column prop="name" label="资费组名" align="center" min-width="120"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>
        <el-table-column prop="serverInfoIds" label="资费列表" align="center" min-width="320">
          <template slot-scope="{row}">
            <div class="product-tags">
              <el-tag
                v-for="item in row.productPriceList.slice(0, PREVIEW_COUNT)"
                :key="item.id || item.productName"
                class="product-tag"
                :class="{ 'is-hit': item.hit == 1 }"
                size="medium"
              >{{ item.productName }}</el-tag>
              <el-popover
                v-if="row.productPriceList.length > PREVIEW_COUNT"
                placement="bottom"
                trigger="click"
                popper-class="product-tags-popover"
              >
                <div class="product-tags-popover__inner">
                  <el-tag
                    v-for="item in row.productPriceList"
                    :key="'pop-' + (item.id || item.productName)"
                    class="product-tag"
                    :class="{ 'is-hit': item.hit == 1 }"
                    size="medium"
                  >{{ item.productName }}</el-tag>
                </div>
                <el-tag
                  slot="reference"
                  class="product-tag product-tag--more"
                  size="medium"
                >+{{ row.productPriceList.length - PREVIEW_COUNT }} 更多</el-tag>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="{row}">
            <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="handleEdit(row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 30, 40]"
      @size-change="handleSizeChange"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>

    <!-- 套餐组编辑弹窗：单列展示 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialog"
      :close-on-click-modal="false"
      :lock-scroll="false"
      width="900px"
      @close="closeDialog"
    >
      <el-form :model="propsParams" :rules="ruleValidate" ref="propsParams" label-width="100px">
        <el-form-item label="资费组名:" prop="productGroupName">
          <el-input
            v-model="propsParams.productGroupName"
            autocomplete="off"
            placeholder="请输入资费组名"
            maxlength="12"
            show-word-limit
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item label="选择套餐:">
          <!--
            关键：必须用 allProducts 全量渲染 option，不能用 availableProducts 剔除已选。
            原因：Element UI 的 el-select 在折叠 tag（collapse-tags）回显时，会按 value 反查
            匹配 option 的 label。若 option 已被剔除，反查失败时就会降级显示 value（纯 ID），
            也就是你看到的 "512" 而不是 "512 - 300M月卡"。
            解决思路：option 全量渲染 + 已选项加 disabled + .pkg-option--selected CSS 隐藏，
            既做到视觉上"下拉剔出"，又让 el-select 能查到 label 显示套餐名。
          -->
          <el-select
            v-model="propsParams.productIdList"
            multiple
            filterable
            collapse-tags
            default-first-option
            clearable
            placeholder="搜索 ID / 套餐名 选择套餐（已选会从下拉移除）"
            style="width: 100%"
            @change="onPackageChange"
          >
            <el-option
              v-for="item in allProducts"
              :key="item.id"
              :label="`${item.id} - ${item.productName}`"
              :value="String(item.id)"
              :disabled="isSelected(item.id)"
              :class="{ 'pkg-option--selected': isSelected(item.id) }"
            />
            <!-- 自定义折叠 tag：用 option.label 显示「ID - 套餐名」，而不是回退到纯 value -->
            <template slot="tag" slot-scope="{ item }">
              <span class="pkg-select-tag" :title="item.label">{{ item.label }}</span>
            </template>
          </el-select>
        </el-form-item>

        <!-- 已选套餐：卡片方块展示，套餐名 + 三家运营价横排，每张卡可单独删除 -->
        <el-form-item label="已选套餐:">
          <div class="selected-packages" v-loading="allProductsLoading">
            <div v-if="displayProducts.length" class="pkg-grid">
              <div
                v-for="row in displayProducts"
                :key="row.id"
                class="pkg-card"
              >
                <!-- 卡片头：套餐名 + 删除按钮（hover 时显示） -->
                <div class="pkg-card__head">
                  <span
                    class="pkg-card__name"
                    :title="`${row.id} - ${row.productName}`"
                  >{{ row.id }} - {{ row.productName }}</span>
                  <i
                    class="el-icon-close pkg-card__remove"
                    title="移除该套餐"
                    @click="removeSelected(row.id)"
                  ></i>
                </div>
                <!-- 卡片体：三家运营商价格横排 -->
                <div class="pkg-card__prices">
                  <span
                    v-for="op in operators"
                    :key="`${row.id}-${op.value}`"
                    class="pkg-price"
                    :class="{ 'is-empty': !getOperatorPrices(row)[op.value] }"
                  >
                    <span class="pkg-price__label">{{ op.shortName }}</span>
                    <span class="pkg-price__value">{{ formatPrice(getOperatorPrices(row)[op.value]) }}</span>
                  </span>
                </div>
              </div>
            </div>

            <div v-else class="selected-packages__empty">
              <i class="el-icon-collection"></i>
              <span>暂未选择套餐，请从上方下拉框选择</span>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div class="dialog-footer" slot="footer">
        <el-button @click="cancelDialog">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  productGroupPage,              // 套餐组分页
  productGroupInfo,              // 套餐组详情
  addProductGroup,               // 新增套餐组
  updateProductGroup,
  groupProductList               // 获取套餐组套餐
} from "@/api/api.js";

export default {
  name: "group",
  data() {
    return {
      // 资费列表单元格最多直接展示 N 个套餐，其余折叠到「+M 更多」里
      PREVIEW_COUNT: 4,
      // 三网运营商标识（短名用于按钮头，全名用于展示）
      operators: [
        { value: '0', shortName: '移动', fullName: '中国移动' },
        { value: '1', shortName: '联通', fullName: '中国联通' },
        { value: '2', shortName: '电信', fullName: '中国电信' }
      ],
      queryParams: {
        name: undefined,
        productName: undefined
      },
      page: 1,
      pageSize: 20,
      total: 20,
      tableData: [],
      // 弹窗相关
      dialog: false,
      saving: false,
      dialogTitle: '创建资费组',
      isEdit: false,
      allProductsLoading: false,
      allProducts: [],            // 全量套餐列表 [{id, productName, products: [...]}]
      propsParams: {
        id: undefined,
        productGroupName: '',
        productIdList: []         // 已选套餐 id 列表（双向绑到 el-select）
      },
      ruleValidate: {
        productGroupName: [
          { required: true, message: '请输入资费组名', trigger: 'blur' },
          { min: 3, max: 12, message: '请输入 3 至 12 位字母数字或汉字', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    /**
     * 显示在「已选套餐」卡片网格里的套餐列表。
     * 兜底链（重要）：
     *   1. 优先查 groupProductList 返回的全量套餐 allProducts（含 productName + products[] 运营价）
     *   2. 查不到时（如该套餐已下架、或 id 类型不一致），回退到后端 productGroupInfo 返回的 productPriceList
     *      （productPriceList 只保证有 productName，可能没有运营价 products[]，相应位置会显示 "—"）
     *   3. 还查不到时，构造一个占位对象 "套餐 {ID}"，至少不让卡片区空白
     */
    displayProducts() {
      const selected = this.propsParams.productIdList || [];
      const allById = new Map(this.allProducts.map(p => [String(p.id), p]));
      const fallbackById = new Map(
        (this.propsParams.productPriceList || []).map(p => [String(p.id || p.productId), p])
      );
      return selected.map(id => {
        const idStr = String(id);
        if (allById.has(idStr)) return allById.get(idStr);
        const fb = fallbackById.get(idStr);
        if (fb) {
          return {
            id: Number(id),
            productName: fb.productName || `套餐 ${id}`,
            products: Array.isArray(fb.products) ? fb.products : []   // 运营价可能缺失
          };
        }
        return {
          id: Number(id),
          productName: `套餐 ${id}`,
          products: []
        };
      });
    }
  },
  methods: {
    /**
     * 限制「资费列表」单元格的最大高度，避免出现「胖子行」。
     */
    cellStyle({ columnIndex }) {
      if (columnIndex === 3) {
        return { maxHeight: '72px', padding: '6px 8px' };
      }
      return {};
    },

    // 获取列表
    queryInfo() {
      const params = {
        model: { ...this.queryParams },
        page: this.page,
        pageSize: this.pageSize
      };
      productGroupPage(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    // 加载全量套餐
    loadAllProducts() {
      if (this.allProducts.length > 0) return Promise.resolve();
      this.allProductsLoading = true;
      return groupProductList()
        .then(res => {
          if (res.data.code == 200) {
            this.allProducts = (res.data.data || []).map(p => ({
              ...p,
              id: p.id
            }));
          }
        })
        .finally(() => {
          this.allProductsLoading = false;
        });
    },

    /**
     * 从套餐的 products[] 抽出三家运营商的价格条目
     * 返回：{ '0': {operatorName, currencySymbal, price}, '1': {...}, '2': {...} }
     * 运营商匹配规则：按 operatorName 的关键字（移动/联通/电信）兜底
     * 匹配不到则为 undefined，调用方展示 "—"
     */
    getOperatorPrices(product) {
      if (!product || !Array.isArray(product.products)) return {};
      const result = {};
      product.products.forEach(item => {
        const name = item.operatorName || '';
        if (name.includes('移动')) result['0'] = item;
        else if (name.includes('联通')) result['1'] = item;
        else if (name.includes('电信')) result['2'] = item;
      });
      return result;
    },

    /** 格式化价格：¥299 / — */
    formatPrice(item) {
      if (!item || item.price == null || item.price === '') return '—';
      const symbol = item.currencySymbal || '¥';
      return `${symbol}${item.price}`;
    },
    /**
     * 判断某个套餐 id 是否已被选中（用于 el-option 上的 disabled + 视觉隐藏 class）
     * 必须用 String 比较，规避 number vs string 类型不一致
     */
    isSelected(id) {
      return (this.propsParams.productIdList || []).some(x => String(x) === String(id));
    },
    /**
     * 从已选套餐里移除指定 id（卡片右上角的 × 触发）
     * 直接 filter productIdList，displayProducts computed 会自动重算
     * 同时清掉校验提示，避免"请至少选择一个套餐"残留
     */
    removeSelected(id) {
      this.propsParams.productIdList = (this.propsParams.productIdList || []).filter(
        item => String(item) !== String(id)
      );
      if (this.$refs.propsParams) {
        this.$refs.propsParams.clearValidate(['productIdList']);
      }
    },

    /**
     * 弹窗里 select 多选变化时同步清掉校验错误，
     * 避免「请输入资费套餐」残留红字干扰。
     */
    onPackageChange() {
      if (this.$refs.propsParams) {
        this.$refs.propsParams.clearValidate();
      }
    },

    /** 新增 */
    addItem() {
      this.dialog = true;
      this.isEdit = false;
      this.dialogTitle = '创建资费组';
      this.propsParams = {
        id: undefined,
        productGroupName: '',
        productIdList: []
      };
      this.loadAllProducts();
    },

    /** 编辑 */
    handleEdit(id) {
      this.dialog = true;
      this.isEdit = true;
      this.dialogTitle = '编辑资费组';

      // 先准备数据再回填，确保 selectable 完整
      this.loadAllProducts().then(() => {
        productGroupInfo({ id }).then(res => {
          const data = res.data.data || {};
          this.propsParams = {
            id: data.id,
            productGroupName: data.productGroupName || data.name || '',
            // 兼容 productPriceList（首选）和 productIdList（兜底）两种后端返回方式
            productIdList: this.normalizeSelectedIds(data),
            // 保存 productPriceList 作为「已选套餐名」的兜底源：
            //   当 groupProductList（allProducts）查不到这个 id 时（套餐下架 / id 类型不一致 / 跨表），
            //   还能从 productPriceList 里把名字拿出来显示，避免只显示 "512" 这种纯 ID
            productPriceList: Array.isArray(data.productPriceList) ? data.productPriceList : []
          };
        });
      });
    },

    /**
     * 把后端返回的"已选套餐"统一成 id 字符串数组：
     *   - 优先用 data.productPriceList[].id / productId
     *   - 否则用 data.productIdList（数组 / 逗号字符串 / "[1,2]" 等）
     *
     * 之所以统一成 **字符串** 而不是 Number：
     *   Element UI 2.15.x 的 el-select.select.vue 中：
     *     getOption(value) {
     *       ...
     *       cachedOption.value === value  // ← 严格相等 (===) ，不转类型
     *     }
     *   一旦 el-option 的 value 是 number、productIdList 元素是 string（或反之），
     *   === 比较失败，el-select 会 fallback 构造虚拟 option 并把 String(value)
     *   作为 currentLabel，折叠 tag 区就只显示纯 ID（"512"）。所以全链路 ID 必须
     *   类型一致，我们选择字符串：在 saveDialog 提交前再 Number() 转回给后端。
     */
    normalizeSelectedIds(data) {
      const toStr = v => (v == null || v === '' ? null : String(v));
      if (Array.isArray(data.productPriceList) && data.productPriceList.length > 0) {
        return data.productPriceList
          .map(p => toStr(p.id || p.productId))
          .filter(v => v && v !== 'null' && v !== 'undefined');
      }
      const raw = data.productIdList;
      if (Array.isArray(raw)) return raw.map(toStr).filter(v => v && v !== 'null' && v !== 'undefined');
      if (raw == null || raw === '') return [];
      return String(raw)
        .replace(/[\[\]"' ]/g, '')
        .split(',')
        .filter(Boolean)
        .map(toStr)
        .filter(v => v && v !== 'null' && v !== 'undefined');
    },

    /** 保存 */
    saveDialog() {
      this.$refs.propsParams.validate(valid => {
        if (!valid) return;
        if (!this.propsParams.productIdList || this.propsParams.productIdList.length === 0) {
          this.$message.warning('请至少选择一个套餐');
          return;
        }
        this.saving = true;
        // 提交时把 String[] 转回 Number[] 给后端（productPriceList 仅作回显兜底，不提交）
        const { productPriceList, ...rest } = this.propsParams;
        const params = {
          ...rest,
          productIdList: (this.propsParams.productIdList || []).map(id => Number(id))
        };
        const apiCall = this.isEdit ? updateProductGroup(params) : addProductGroup(params);
        apiCall
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success(this.isEdit ? '编辑套餐组成功' : '创建套餐组成功');
              this.dialog = false;
              this.queryInfo();
            } else {
              this.$message.error(res.data.message || '操作失败');
            }
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },

    /** 关闭弹窗 */
    closeDialog() {
      if (this.$refs.propsParams) {
        this.$refs.propsParams.clearValidate();
      }
      this.dialog = false;
    },

    /** 取消 */
    cancelDialog() {
      this.dialog = false;
    },

    // 搜索 / 重置 / 分页
    search() {
      this.page = 1;
      this.queryInfo();
    },
    resetQuery() {
      this.resetForm('queryForm');
      this.queryInfo();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.queryInfo();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.queryInfo();
    }
  },
  created() {
    this.queryInfo();
  }
};
</script>

<style scoped lang="less">
/* 行内套餐标签列表：紧凑展示 + 单行高度受限，避免「胖子行」 */
.product-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  max-height: 72px;
  overflow: hidden;
  line-height: 1.4;
}

.product-tag {
  margin: 0 !important;            /* 覆盖 element 默认外边距，由 gap 统一接管 */
  &.is-hit {
    background-color: #fef0f0;
    border-color: #fde2e2;
    color: #f56c6c;
  }
  &--more {
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
    &:hover {
      color: #409eff;
      border-color: #b3d8ff;
      background-color: #ecf5ff;
    }
  }
}

/* 已选套餐展示区：弹性网格容器 */
.selected-packages {
  width: 100%;
  min-height: 88px;
  max-height: 500px;            /* ← 新增：限制最大高度，超出滚动 */
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  overflow-y: auto;             /* ← 新增：垂直滚动 */

  /* 美化滚动条，避免太丑 */
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #909399;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 36px 0;
    color: #c0c4cc;
    font-size: 13px;

    i {
      font-size: 18px;
    }
  }
}

/* 卡片网格：卡片左右排列，超出一行自动折行 */
.pkg-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* 套餐卡片：浅边框 + 圆角 + hover 出现删除按钮 */
.pkg-card {
  position: relative;
  flex: 1 1 calc(50% - 5px);   /* 一行两列，弹性分配宽度 */
  min-width: 260px;
  max-width: calc(50% - 5px);
  padding: 5px 10px;                  /* ← 8 → 5，垂直紧凑一半 */
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  transition: border-color 0.18s ease, background-color 0.18s ease, box-shadow 0.18s ease;
  line-height: 1.4;                   /* ← 收紧行高 */

  &:hover {
    border-color: #409eff;
    background-color: #ecf5ff;
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.08);

    .pkg-card__remove {
      opacity: 1;
      transform: scale(1);
    }
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    padding-bottom: 2px;              /* ← 6 → 2 */
    border-bottom: 1px dashed #e6e8eb;
  }

  &__name {
    flex: 1;
    min-width: 0;
    font-size: 12px;                   /* ← 13 → 12 */
    font-weight: 600;
    color: #303133;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__remove {
    flex-shrink: 0;
    cursor: pointer;
    padding: 0 2px;
    font-size: 14px;                   /* ← 16 → 14 */
    color: #c0c4cc;
    border-radius: 50%;
    opacity: 0;
    transform: scale(0.85);
    transition: opacity 0.18s ease, color 0.18s ease, background-color 0.18s ease, transform 0.18s ease;

    &:hover {
      color: #fff;
      background-color: #f56c6c;
    }
  }

  &__prices {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px 10px;                     /* ← 4 12 → 2 10 */
    padding-top: 2px;                  /* ← 6 → 2 */
  }
}

/* 单家运营商价：名字 + 金额 紧凑排列 */
.pkg-price {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  font-size: 11px;                     /* ← 12 → 11 */
  color: #606266;
  white-space: nowrap;
  line-height: 1.2;                    /* ← 收紧 */

  &__label {
    color: #909399;
  }

  &__value {
    color: #f56c6c;
    font-weight: 600;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', monospace;
  }

  &.is-empty {
    opacity: 0.5;

    .pkg-price__value {
      color: #c0c4cc;
      font-weight: 400;
    }
  }
}

/* 弹窗底部按钮 */
.dialog-footer {
  text-align: right;
}

/*
  el-select 下拉里已选的套餐：从 DOM 层面隐藏（display:none），保持 option 仍存在，
  这样折叠 tag（collapse-tags）回显时能查到 option.label，显示套餐名。
  仅在 el-select-dropdown 内生效，不污染弹窗中的选项。
*/
.el-select-dropdown__item.pkg-option--selected {
  display: none !important;
}

/* 折叠 tag 内的套餐文字，避免太长挤压 */
.pkg-select-tag {
  display: inline-block;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>

<!-- popover 内部需要跨组件覆盖，单独放在非 scoped 块 -->
<style lang="less">
.product-tags-popover {
  max-width: 480px;
  padding: 8px 4px !important;
  .product-tags-popover__inner {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 6px;
    max-height: 260px;
    overflow-y: auto;
    padding: 4px 8px;
  }
}
</style>
